var locale = {
  placeholder: 'Select time'
};
export default locale;
//# sourceMappingURL=en_US.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/time-picker/locale/en_US.js
// module id = 176
// module chunks = 0